import { DetailLabels, SectionTitle } from '../@types/general';
import { LeadDetail, PropertyDetail } from '../@types/lead';

export const LEAD_DETAIL_LABELS: DetailLabels<Omit<LeadDetail, 'materialList'>> = {
  contactInfo: {
    email: 'detailLabels.email',
    phone: 'detailLabels.phone',
    zip: 'detailLabels.zip',
    leadName: 'detailLabels.leadName',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
  },
  aboutLead: {
    predictiveCloseRate: 'Predictive Close Rate',
    leadLabel: 'detailLabels.leadLabel',
    source: 'Source',
    entryPoint: 'Entry Point',
    lastActivity: 'Last Activity',
  },
  projectDetails: {
    timeSpent: 'Time Spent',
    designsMade: 'Designs Made',
    totalProductsApplied: 'Total Products Applied',
    numberOfColorsApplied: 'Number of colors Applied',
    numberOfPageViews: 'Number of Page views',
  },
};

export const PROPERTY_DETAIL_LABELS: DetailLabels<PropertyDetail> = {
  property: {
    roofArea: 'Roof Area',
    roofSquares: 'Roof Squares',
    roofToGround: 'Roof to Ground',
    roofSegmentCount: 'Roof Segment Count',
    roofPredominatePitch: {
      largestSegmentPitch: 'Largest Segment Pitch',
      weightedAveragePitch: 'Weighted Average Pitch',
    },
  },
  location: {
    lat: 'Latitude',
    long: 'Longitude',
  },
};

export const SECTION_TITLES: Array<SectionTitle> = [
  { name: 'contactInfo', text: 'detailLabels.contactInfo' },
  { name: 'aboutLead', text: 'detailLabels.aboutLead' },
  { name: 'projectDetails', text: 'detailLabels.projectDetails' },
  { name: 'materialList', text: 'Material List' },
  { name: 'instantEstimates', text: 'instantEstimate.sectionTitle' },
  { name: 'initialProjectImage', text: 'Project Design Before' },
  { name: 'finalProjectImage', text: 'Project Design After' },
  { name: 'appliedProduct', text: 'Applied Products' },
  { name: 'property', text: 'Property' },
  { name: 'location', text: 'Location' },
];

export const MAP_LABELS = {
  propertyLocation: 'Property Location',
};

export const MATERIAL_TYPE_LOCALE_KEYS: Record<string, string> = {
  asphalt: 'instantEstimate.materials.asphalt',
  metal: 'instantEstimate.materials.metal',
  tile: 'instantEstimate.materials.tile',
  slate: 'instantEstimate.materials.slate',
  wood: 'instantEstimate.materials.wood',
  lowSlope: 'instantEstimate.materials.lowSlope',
  synthetic: 'instantEstimate.materials.synthetic',
};
